export type AppEnvironment = "production" | "staging" | "development" | "local";

/**
 * 현재 hostname 기준으로 실행 환경을 판정한다.
 * Sentry 환경 분기·Clarity 게이팅 등 production 판정이 필요한 곳에서 공통으로 사용한다(SSOT).
 */
export const getEnvironment = (): AppEnvironment => {
  const hostname = window.location.hostname;
  if (hostname === "app.invector.co") return "production";
  if (hostname.includes("wxbrl-staging")) return "staging";
  if (hostname.includes("wxbrl-dev")) return "development";
  return "local";
};
